"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationContextProvider = ValidationContextProvider;
exports.ValidationError = ValidationError;
exports.useIsValid = useIsValid;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ValidationContext = /*#__PURE__*/_react.default.createContext(true);
const ValidationSettersContext = /*#__PURE__*/_react.default.createContext(undefined);
function ValidationContextProvider({
  children
}) {
  const [validationErrorCount, setValidationErrorCount] = _react.default.useState(0);
  const validationSetters = _react.default.useMemo(() => ({
    onErrorAdded: () => setValidationErrorCount(c => c + 1),
    onErrorRemoved: () => setValidationErrorCount(c => c - 1)
  }), [setValidationErrorCount]);
  return /*#__PURE__*/_react.default.createElement(ValidationContext.Provider, {
    value: validationErrorCount === 0
  }, /*#__PURE__*/_react.default.createElement(ValidationSettersContext.Provider, {
    value: validationSetters
  }, children));
}

/**
 * Returns true if there are no <ValidationError />
 * components rendered on the page
 */
function useIsValid() {
  return _react.default.useContext(ValidationContext);
}

/**
 * Rendering this component marks the current page
 * as containing a validation error. This prevents
 * the user moving focus out of any editable field.
 *
 * Removing this component returns the form to being
 * valid.
 *
 * This component does not have any visible output.
 */
function ValidationError() {
  const context = _react.default.useContext(ValidationSettersContext);
  _react.default.useEffect(() => {
    if (!context) {
      throw new Error('ValidationError must be used within a ValidationContextProvider');
    }
    context.onErrorAdded();
    return context.onErrorRemoved;
  }, [context]);
  return null;
}